<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<div v-for="(item, index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:multiple="item.multiple" :types="item.types" :inputtype="item.inputtype" :width="item.width">
					</Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Secondarydealerfilestable :tableData="tableData" :total="total"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Secondarydealerfilestable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import Secondarydealerfilestable from "./components/secondarydealerfilestable.vue";
	import {
		InventoryClassList,
	} from '@/api/home'

	import {
		GetIMSNTSList,
		GetHelperVBP,
		GetProvinceCityTree
	} from "@/api/newsapi";
	import utils from "../../../common/utils";
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Secondarydealerfilestable,
		},
		data() {
			return {
				showorhide: true,
				CusName: "",
				InvClass: "",
				Year: "",
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				form: {},
				formdata: [{
						inputdata: "",
						title: "产品线",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "210px",
						btx: true,
						options: [],
						lablewith: '110px',
						event: "invClass"
					}, {
						inputdata: "",
						title: "类型",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "315px",
						btx: true,
						options: [],
						lablewith: '120px',
						event: "invClass"
					},
					{
						inputdata: "",
						title: "政策名称",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "305px",
						lablewith: "117px",
					},
					{
						inputdata: "",
						title: "省市",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "cascaderNodeParent",
						width: "210px",
						lablewith: "110px",
						multiple: true,
						height: '30px',
						btx: false,
					}, {
						inputdata: "",
						title: "执行日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "date",
						width: "200px",
						lablewith: "117px",
					}, {
						inputdata: "",
						title: "创建日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "date",
						width: "200px",
						lablewith: "115px",
					}, {
						inputdata: "",
						title: "产品名称/L3",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "200px",
						lablewith: "110px",
					}, {
						inputdata: "",
						title: "经销商",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "305px",
						lablewith: "120px",
					}
				],
			};
		},
		mounted() {
			this.customerList();
			this.inventoryClassList();
			this.getHelperVBP();
			this.getProvinceCityTree();
		},
		methods: {
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[0].options.push(obj);
					})
				}
			},
			//类型
			async getHelperVBP() {
				let {
					code,
					data
				} = await GetHelperVBP({});
				if (code == 0) {
					this.formdata[1].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text,
						};
						this.formdata[1].options.push(obj);
					});
					this.$forceUpdate();
				}
			},
			//省市
			async getProvinceCityTree() {
				let {
					code,
					data
				} = await GetProvinceCityTree({});
				if (code == 0) {
					this.formdata[3].options = data;
					this.$forceUpdate();
				}
			},
			// 列表
			async customerList() {
				let {
					data,
					code
				} = await GetIMSNTSList({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			reset() {
				this.$refs.seselect.map((item, index) => {
					item.modelvalue = "";
					item.startTime = "";
					item.endTime = "";
				});
			},
			select() {
				this.pageindex = 1;
				this.form.InvClass = this.$refs.seselect[0].modelvalue;
				this.form.INType = this.$refs.seselect[1].modelvalue;
				this.form.INName = this.$refs.seselect[2].modelvalue;
				this.form.ProvinceCityDetails = this.$refs.seselect[3].modelvalue ? this.$refs.seselect[3].modelvalue
					.join(',') : '';
				this.form.ExecuteDate1 = this.$refs.seselect[4].startTime;
				this.form.ExecuteDate2 = this.$refs.seselect[4].endTime;
				this.form.CreateTime1 = this.$refs.seselect[5].startTime;
				this.form.CreateTime2 = this.$refs.seselect[5].endTime;
				this.form.Inventory = this.$refs.seselect[6].modelvalue;
				this.form.Customer = this.$refs.seselect[7].modelvalue;
				this.customerList();
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.customerList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.customerList();
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 210px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 90px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>